<template>
  <div class="geo-container">
    <div class="area">
      <div class="row" v-animated-show="utils.handleScroll">
        <h2 class="col-12 col-md-12" v-html="title"></h2>
        <Map
          class="col-6 col-md-12"
          :title="map.title"
          :places="map.places"
          :is-catalog="true"
          id="catalog-nav"
        />
        <div class="spacer col-1 md-hidden"></div>
        <div class="info col-5 col-md-12">
          <h3 v-html="pros.title" class="col-3 col-md-12"></h3>
          <div
            v-for="(l, i) in pros.list"
            class="pros-item col-5 col-md-12"
            :class="[l.icon]"
            :key="i"
          >
            <Description
              class=" default col-2"
              ref="bannerDescription"
              :isMoreTop="true"
              :title="l.title"
              :desc="l.desc"
            />
            <Description
              class=" default col-2"
              ref="bannerDescription"
              :isMoreTop="true"
              :title="l.plans.title"
              :desc="l.plans.desc"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
import Map from "../containers/Map";
export default {
  name: "Geo",
  props: {
    theme: {
      default: "default",
    },
    map: Object,
    title: String,
    pros: Object,
  },
  data() {
    return {
      utils: utils,
      current: 0,
    };
  },
  methods: {
    nextFeedback(offset) {
      this.current = Math.min(this.current + offset, this.list.length - 1);
    },
  },
  mounted() {
    this.current = 0;
  },
  components: { Map },
};
</script>

<style lang="scss">
.geo-container {
  background: $bg-main;
  h2 {
    font-weight: bold;
    @media all and (max-width: $md) {
      font-size: 24px;
    }
  }
  @extend %page-block;
  .info {
    display: grid;
    grid-gap: 42px 0;
    align-items: flex-start;
    align-content: flex-start;
    margin-top: 52px;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    h3 {
      @media all and (max-width: $md) {
        margin-right: 0;
      }
      margin-right: -26px;
    }
    .pros-item {
      @media all and (max-width: $md) {
        grid-template-columns: 88px auto auto;
        grid-gap: 12px;
      }
      display: grid;
      grid-template-columns: repeat(5, minmax(0, 1fr));
      grid-gap: 15px 26px;
      &::before {
        margin-top: 20px;
        font-size: 34px;
        color: $text-main;
        grid-column: 1;
      }
      &:nth-child(3) {
        &::before {
          margin-top: 10px;
        }
      }
      .description {
        .description-content {
          grid-gap: 10px;
          margin-right: 26px;
          .title {
            font-size: 36px;
          }
          .desc {
            font-size: 12px;
          }
        }
        &:nth-child(2) {
          @media all and (max-width: $md) {
            grid-row: 2;
            grid-column: 2;
          }
          .title {
            color: $text-main-quart;
          }
          .desc {
            color: $text-main-quart;
          }
        }
      }
    }
  }
}
</style>
